import { Button, Typography } from "components/atoms";
import "./index.scss";

interface IProps {
  isDisableContinue: boolean;
  isLoading: boolean;
  handleContinue: () => void;
  handleLater: () => void;
}

export const FormNavigationSection = ({
  isDisableContinue,
  isLoading,
  handleContinue,
  handleLater,
}: IProps) => {
  return (
    <div className="form-navigation-wrapper">
      <div className="btn-with-text-wrapper">
        <Button
          icon={false}
          type="score"
          label="Continue"
          styles="continue-btn-style"
          isLoading={isLoading}
          isDisabled={isDisableContinue}
          onClick={handleContinue}
        />
        <Typography
          label="Later"
          variant="h8Med"
          styles="later-text-custom-style"
          onClick={handleLater}
        />
      </div>
    </div>
  );
};
